function resolveBaseUrl() {
  const envUrl = (process.env.REACT_APP_ORDER_FULFILLMENT_API_URL || '').trim();
  if (envUrl) {
    return envUrl.replace(/\/$/, '');
  }

  return 'https://dev-agent.savictech.com/of/odfapi';
}

const BASE_URL = resolveBaseUrl();

async function apiFetch(path, options = {}) {
  try {
    return await fetch(`${BASE_URL}${path}`, options);
  } catch (err) {
    throw new Error(
      `Cannot connect to Order Fulfillment backend at ${BASE_URL}. ` +
      'Set REACT_APP_ORDER_FULFILLMENT_API_URL if needed.'
    );
  }
}

async function handleResponse(res) {
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;

    try {
      const data = await res.json();
      if (typeof data?.detail === 'string') {
        detail = data.detail;
      } else {
        detail = JSON.stringify(data);
      }
    } catch (_) {}

    throw new Error(detail);
  }

  return res.json();
}

function buildQs(params = {}) {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== '' && value !== undefined && value !== null)
  );

  const qs = new URLSearchParams(clean).toString();
  return qs ? `?${qs}` : '';
}

export const getDashboardSummary = () =>
  apiFetch('/dashboard/summary').then(handleResponse);

export const getPendingOrders = (params = {}) =>
  apiFetch(
    `/orders/pending${buildQs({
      risk_level: params.risk_level || 'all',
      plant_key: params.plant_key,
      customer_name: params.customer_name,
      days_left_max: params.days_left_max,
      limit: params.limit,
    })}`
  ).then(handleResponse);

export { BASE_URL as ORDER_FULFILLMENT_API_BASE_URL };
